import { entityScripts } from "@/lib/entityJsonLd";
import { createFileRoute } from "@tanstack/react-router";
import CompetitionHub from "@/pages/CompetitionHub";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findCompetition } from "@/lib/entities";

export const Route = createFileRoute("/competitions/$slug")({
  head: ({ params }) => {
    const label = findCompetition(params.slug)?.label ?? readable(params.slug);
    return {
      scripts: entityScripts({ type: "SportsOrganization", name: label, path: `/competitions/${params.slug}`, crumbs: [{ name: "Competitions", path: "/competitions" }, { name: label, path: `/competitions/${params.slug}` }], extra: { sport: "Association football" } }),
      meta: socialMeta({
        seo: { topics: [params.slug, "leagues", "footballPredictions"], entities: [readable(params.slug)] },
        title: `${label} Predictions & Betting Tips | Statlign`,
        description: `${label} predictions, value odds and betting tips backed by our 50-strategy analysis engine. Upcoming ${label} fixtures across all major markets.`,
      }),
    };
  },
  component: () => (
    <MainLayout>
      <CompetitionHub />
    </MainLayout>
  ),
});
